import Header from "@components/common/Header";
import { NavLink } from "react-router-dom";
import "./open-details.scss";
import "./index.scss";
import { getValue } from "@utils/lodash";
import InputField from "@_common/InputRuleFeild";
import { useRef, useState } from "react";
import { Modal } from "reactstrap";

export default function SupportAddPopup(props: any) {
  /* -------------------------------------------------------------------------- */
  /*                               UseState Section                             */
  /* -------------------------------------------------------------------------- */

  const [module] = useState([
    { value: "REPORTS", label: "Reports" },
    { value: "VENDOR", label: "Vendor" },
    { value: "PE_COMPLIANCE", label: "PE Compliance" },
    { value: "SELF_COMPLIANCE", label: "Self Compliance" },
    { value: "LICENSE", label: "License" },
    { value: "LOGIN", label: "Login" },
    { value: "BUG", label: "Bug" },
    { value: "OTHER", label: "Other" },
  ]);

  const [severity] = useState([
    { value: "HIGH", label: "High" },
    { value: "MEDIUM", label: "Medium" },
    { value: "LOW", label: "Low" },
  ]);

  const {
    request,
    simpleValidator,
    handleChangeRequest,
    handleChangeSelect,
  } = props;

  return (
    <div
      className={`compelte-task-wrapper-add ${
        props.isOpen ? "compelte-task-wrapper--active" : ""
      }`}
    >
      <div className="compelte-task-wrapper__header d-flex align-items-center justify-content-between">
        <h6 className="compelte-task-wrapper__title">Create Ticket</h6>
        <img
          src="/images/close-white.svg"
          className="img-fluid navigation-bar-wrapper__close-btn"
          onClick={props.handleModal}
        />
      </div>

      <div className="compelte-task-wrapper__body d-flex">
        <div className="support-wrapper">
          <div className="module-wrapper__form-group form-group">
            <label className="status-details-wrapper__label">Module *</label>
            {/* <label className="module-wrapper__label"></label> */}
            {/* <select className="module-wrapper__select">
              <option>Reports</option>
            </select> */}

            <InputField
              inputType="INPUT_REACT_SELECT"
              name="module"
              placeholder="Enter Module"
              options={module}
              onChange={(e: any) => handleChangeSelect(e, "module")}
              value={module.filter(
                (item: any) =>
                  getValue(request, `module`, "") ===
                  getValue(item, `value`, "")
              )}
              validator={simpleValidator}
              label={"Module"}
            />
          </div>
          <div className="module-wrapper__form-group form-group">
            <label className="status-details-wrapper__label">Severity *</label>
            {/* <select className="module-wrapper__select">
              <option>High</option>
            </select> */}
            <InputField
              inputType="INPUT_REACT_SELECT"
              name="severity"
              placeholder="Enter Severity"
              options={severity}
              onChange={(e: any) => handleChangeSelect(e, "severity")}
              value={severity.filter(
                (item: any) =>
                  getValue(request, `severity`, "") ===
                  getValue(item, `value`, "")
              )}
              validator={simpleValidator}
              label={"Severity"}
            />
          </div>
          <div className="module-wrapper__form-group form-group">
            <label className="status-details-wrapper__label">
              Ticket Title *
            </label>
            {/* <div className="module-wrapper__text-details"> */}
            {/* <p className="module-wrapper__text">
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry’s standard dummy
                text ever since the 1500s
              </p> */}
            <InputField
              inputType="TEXTAREA"
              name="ticket_title"
              placeholder="Enter Ticket Title"
              onChange={(e: any) => handleChangeRequest(e)}
              value={getValue(request, `ticket_title`, "")}
              validator={simpleValidator}
              label={"Ticket Title"}
            />
            {/* </div> */}
          </div>
          <div className="module-wrapper__form-group form-group">
            <label className="status-details-wrapper__label">Description</label>
            {/* <div className="module-wrapper__text-details">
              <p className="module-wrapper__text">
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry’s standard dummy
                text ever since the 1500s, when an unknown printer took a galley
                of type and scrambled it to make a type specimen book. It has
                survived not only five centuries, but also the leap into
                electronic typesetting, remaining essentially unchanged.
              </p>
            </div> */}
            <InputField
              inputType="TEXTAREA"
              name="description"
              placeholder="Enter Description"
              onChange={(e: any) => handleChangeRequest(e)}
              value={getValue(request, `description`, "")}
            />
          </div>
        </div>
      </div>
      <div className="user-details-wrapper-add">
        <button
          className="user-details-wrapper__cta-btn user-details-wrapper__cta-btn--primary"
          onClick={props.handleModal}
        >
          Cancel
        </button>

        <button
          className="user-details-wrapper__cta-btn user-details-wrapper__cta-btn--secondary"
          disabled={props.submitLoading}
          onClick={props.handleSubmit}
        >
          {props.submitLoading ? "Please wait..." : "Submit"}
        </button>
      </div>
    </div>
  );
}
